"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonLayoutWrapper = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dedupe = _interopRequireDefault(require("classnames/dedupe"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Container to center/space buttons
 */
var ButtonLayoutWrapper = function ButtonLayoutWrapper(_ref) {
  var children = _ref.children,
      isSmall = _ref.isSmall;
  var containerProps = {
    className: (0, _dedupe.default)('control-container', {
      'control-container--small': isSmall
    })
  };
  return _react.default.createElement("div", containerProps, children);
};

exports.ButtonLayoutWrapper = ButtonLayoutWrapper;
ButtonLayoutWrapper.defaultProps = {
  isSmall: false
};
ButtonLayoutWrapper.propTypes = {
  children: _propTypes.default.node.isRequired,
  isSmall: _propTypes.default.bool
};